<template lang="pug">
    #collaborator
        v-card.page-card
            v-card-text
                .hint.mb-6
                    span.font-weight-bold(v-if="type==0") {{$t('Collaborators.__CreateAccount')}}
                    span(v-else)
                        a.text-decoration-underline(@click="type=0") {{$t('Collaborators.__CreateAccount')}}
                    span.mx-2  |
                    span.font-weight-bold(v-if="type==1") {{$t('Collaborators.__LogInToJoin')}}
                    span(v-else)
                        a.text-decoration-underline(@click="type=1") {{$t('Collaborators.__LogInToJoin')}}
                v-form(v-model="formValid" ref="collaboratorform")
                    //- v-alert.text-left(v-if="alertText != ''" outlined dense  type="error") {{alertText}}
                    Alert(permanent)
                    v-text-field.page-input-field(v-if="type==0" v-model="name" solo dense outlined :rules="[rules.required]" :placeholder="$t('ContactInfo.__WhatsYourName')" )
                    v-text-field.page-input-field(v-model="email" solo dense outlined :rules="[rules.required, rules.email]" :placeholder="$t('Auth.__EnterEmail')" )
                    v-text-field.page-input-field(v-model="password" solo dense outlined :rules="[rules.required, rules.password]" :placeholder="type==0?$t('Auth.__SetPassword'):$t('Auth.__EnterPassword')" :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'" @click:append="passwordShow = !passwordShow" :type="passwordShow ? 'text' : 'password'" @input="$refs.collaboratorform.validate()")
                    v-text-field.page-input-field(v-if="type==0" v-model="confirmedPassword" solo dense outlined :rules="[rules.required, confirmPassword]" :placeholder="$t('Auth.__ConfirmPassword')" type="password")
                    v-btn.page-btn.mb-6(v-if="type==0" block rounded color="primary" @click="register") {{$t('Auth.__Continue')}}
                    v-btn.page-btn.mb-6(v-if="type==1" block rounded color="primary" @click="login") {{$t('Auth.__Login') }}
                    //- .hint.text-left Use this email and password to
                    //- v-row
                    //-     v-col(cols="6")
                    //-         v-btn.page-btn.mb-6(block rounded outlined color="primary" @click="register") {{$t('Auth.__CreateUser')}}
                    //-     v-col(cols="6")
                    //-         v-btn.page-btn.mb-6(block rounded color="primary" @click="register") {{$t('Auth.__Login')}}

                .text-or.text-center.mb-4 
                    span {{$t('Auth.__Or')}}
                v-btn#google-btn.google-btn.mb-4(block rounded dark color="#4285f4") 
                    v-avatar(left size="30" )
                        v-img(src="@/assets/images/icon-google.png")
                    | {{$t('Auth.__ContinueWithGoogle')}}
                .text 
                    i18n(path="Auth.__Agreement")
                        a.mr-2(href="https://www.2sumup.com/blank-1" target="_blank") {{$t('Auth.__TermsOfService')}}
                        a(href="https://www.2sumup.com/blank-2" target="_blank") {{$t('Auth.__PrivacyPolicy')}}

                        

</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"
import * as googleAuth from "@/utils/googleAuth"

export default {
  data: () => ({
    type: 0,
    invitedEmail: null,
    invitedToken: null,
    bizId: null,
    formValid: false,
    rules: textfieldUtils.rules,
    passwordShow: false,
    name: "",
    email: "",
    password: "",
    confirmedPassword: "",
    alertText: "",
    resendBtnTittle: "",
    resendBtnTittle02: "重新寄送驗證信",
    countdown: 10,
    interval: null,
    signupObject: {}
  }),
  methods: {
    confirmPassword(value) {
      return this.password == value || this.$t("Form.__PasswordsMustBeSame")
    },
    login() {
      this.$store.dispatch("global/closeAlert")
      this.$refs.collaboratorform.validate()
      if (this.invitedEmail != this.email) {
        this.$store.dispatch("global/showAlert", {
          type: "error",
          message: this.$t("Form.__InvalidEmail")
        })
        return
      }
      if (this.formValid) {
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("auth/login", {
            email: this.email,
            password: this.password
          })
          .then(
            function(response) {
              this.loginSuccess(response.data.accessToken, false)
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      }
    },
    register() {
      this.$refs.collaboratorform.validate()
      if (this.invitedEmail != this.email) {
        this.$store.dispatch("global/showAlert", {
          type: "error",
          message: this.$t("Form.__InvalidEmail")
        })
        return
      }
      if (this.formValid) {
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("collaborators/createCollaborator", {
            bid: this.bizId,
            email: this.email,
            password: this.password,
            invitationToken: this.invitedToken,
            name: this.name
          })
          .then(
            function(response) {
              this.loginSuccess(response.data.accessToken, true)
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      }
    },
    loginByGoogle(token) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("auth/loginByGoogle", { token })
        .then(
          function(response) {
            this.loginSuccess(response.data.accessToken, false)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    loginSuccess(accessToken, registerTag) {
      this.$store.dispatch("auth/logout")
      this.$store.dispatch("account/logout")
      this.$store.dispatch("bizes/logout")
      this.$store
        .dispatch("auth/updateToken", {
          token: accessToken
        })
        .then(
          function(response) {
            if (registerTag == true) {
              this.$store.dispatch("account/updateUsedBiz", this.bizId).then(
                function() {
                  this.getMe()
                }.bind(this)
              )
            } else {
              this.$store
                .dispatch("collaborators/joinCollaborator", {
                  bid: this.bizId,
                  invitationToken: this.invitedToken
                })
                .then(
                  function(response) {
                    this.$store.dispatch("account/updateUsedBiz", this.bizId).then(
                      function() {
                        this.getMe()
                      }.bind(this)
                    )
                  }.bind(this)
                )
                .catch(
                  function(error) {
                    this.$store.dispatch("auth/logout")
                    this.$store.dispatch("account/logout")
                    this.$store.dispatch("bizes/logout")

                    this.$store.dispatch("global/showAlertError", error.message)
                    this.$store.dispatch("global/stopLoading")
                  }.bind(this)
                )
            }
          }.bind(this)
        )
    },
    getMe() {
      this.$store
        .dispatch("account/me")
        .then(
          function(response) {
            var user = response.data
            this.$store.dispatch("account/updateUser", response.data)
            this.getBiz(response.data.lastlyUsedBusinessId)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getBiz(bizId) {
      if (bizId != null) {
        this.$store
          .dispatch("bizes/getBiz", bizId)
          .then(
            function(response) {
              this.$store.dispatch("bizes/updateBizInfo", response.data)
              this.$router.push({
                name: "Dashboard",
                params: {
                  alert: {
                    message: this.$t("Messages.__JoinSuccessfully", { bizName: this.$route.query.bn }),
                    type: "success"
                  }
                }
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      } else {
        this.$router.push("/" + this.$i18n.locale + "/business-info")
        this.$store.dispatch("global/stopLoading")
      }
    }
  },
  computed: {},
  mounted() {
    var vm = this
    googleAuth
      .getAuth2()
      .then(auth2 => {
        auth2.attachClickHandler(
          document.getElementById("google-btn"),
          {},
          function(googleUser) {
            vm.loginByGoogle(googleUser.getAuthResponse().id_token)
          },
          function(error) {}
        )
      })
      .catch(error => {
        // this.$store.dispatch("global/showAlert", {
        //     type: "error",
        //     message: "google auth fail"
        // })
      })

    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {
    this.invitedToken = this.$route.query.t
    this.bizId = this.$route.query.biz
    this.invitedEmail = this.email = this.$route.query.im

    const token = localStorage.getItem("token")
    if (token) {
      var userEmail = this.$store.getters["account/email"]()
      if (userEmail == this.invitedEmail) {
        this.loginSuccess(token, false)
      }
    }
    if (this.invitedToken && this.bizId && this.invitedEmail) {
      //pass
    } else {
      this.$router.push("/" + this.$i18n.locale + "/login")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";

.register-stepper {
  box-shadow: 0 0 0 0;
  .v-stepper__content {
    padding: 0;
  }
}
</style>
